import React from "react";
import "../../../modal.css";

export default function ServiceRestartChatConfirmation({ confirmationAction }) {
    return (
        <div id="popup2" class="overlay open">
            <div class="chatpopup">
                <div class="feedbackdone">
                    <>
                        <div className="heading textleft">Looks like you have a chat session open with us. How would you like to proceed?</div>
                        <div class="chatclose-option">

                            <div className="chatBtn" onClick={() => confirmationAction(false)}>Continue previous chat</div>
                            <div className="chatBtn" onClick={() => confirmationAction(true)} >Start a new chat</div>
                        </div>
                    </>
                </div>
            </div>
        </div>
    );
}